import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { DesignSystemModule, Pagination } from '@peca/design-system';

@Component({
  selector: 'peca-load-more',
  templateUrl: './load-more.component.html',
  styleUrl: './load-more.component.scss',
  imports: [CommonModule, DesignSystemModule],
})
export class LoadMoreComponent {
  pagination = input.required<Pagination>();
  loadMore = output<Pagination>();

  onClickLoadMore(): void {
    const pagination = this.pagination();
    this.loadMore.emit({ ...pagination, page: pagination.page + 1 });
  }

  hasReachedLastPage(): boolean {
    const pagination = this.pagination();
    return pagination.page >= pagination.total;
  }
}
